import { useContext } from 'react';

import { ThemeContext, type ThemeState } from './ThemeContext';

export function useTheme(): ThemeState {
  const state = useContext(ThemeContext);

  if (!state) {
    throw new Error('useTheme вызван вне ThemeProvider');
  }

  return state;
}
